import { Controller, Control, FieldErrors } from 'react-hook-form';
import { LoanFormData } from '@/schemas/loanSchema';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface Props {
  control: Control<LoanFormData>;
  errors: FieldErrors<LoanFormData>;
}

export const SchedulesSection = ({ control }: Props) => (
  <div className="p-8 mb-8" data-test-id="schedules-container">
    <h3 className="section-title" data-test-id="schedules-title">
      Schedule Modifications
    </h3>
    <div className="grid-2" data-test-id="schedules-grid">
      <div data-test-id="default-interest-schedule-field">
        <Label
          className="form-label loanform-label"
          htmlFor="schedules.default_interest_schedule"
          data-test-id="default-interest-schedule-label"
        >
          Default Interest Schedule
        </Label>
        <Controller
          name="schedules.default_interest_schedule"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              id="schedules.default_interest_schedule"
              className="input-full loanform-input loanform-input-bg loanform-input-border"
              value={field.value ?? ''}
              data-test-id="default-interest-schedule-input"
            />
          )}
        />
      </div>
      <div data-test-id="preferred-equity-schedule-field">
        <Label
          className="form-label loanform-label"
          htmlFor="schedules.preferred_equity_equity_kicker_schedule"
          data-test-id="preferred-equity-schedule-label"
        >
          Preferred Equity/Equity Kicker Schedule
        </Label>
        <Controller
          name="schedules.preferred_equity_equity_kicker_schedule"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              id="schedules.preferred_equity_equity_kicker_schedule"
              className="input-full loanform-input loanform-input-bg loanform-input-border"
              value={field.value ?? ''}
              data-test-id="preferred-equity-schedule-input"
            />
          )}
        />
      </div>
    </div>

    <h4
      className="text-lg font-semibold mb-4 mt-6"
      data-test-id="bespoke-schedules-title"
    >
      Bespoke Schedules
    </h4>
    <div className="grid-2 mb-4" data-test-id="bespoke-schedules-grid">
      <div data-test-id="proforma-assumptions-field">
        <Label
          className="form-label loanform-label"
          htmlFor="credit_utilization.proforma_assumptions"
          data-test-id="proforma-assumptions-label"
        >
          Credit Utilization Proforma Assumptions
        </Label>
        <Controller
          name="credit_utilization.proforma_assumptions"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              className="input-full loanform-input loanform-input-bg loanform-input-border"
              value={field.value ?? ''}
              data-test-id="proforma-assumptions-input"
            />
          )}
        />
      </div>
      <div data-test-id="custom-interest-type-timing-field">
        <Label
          className="form-label loanform-label"
          htmlFor="credit_utilization.custom_interest_type_timing"
          data-test-id="custom-interest-type-timing-label"
        >
          Custom Interest Type Timing
        </Label>
        <Controller
          name="credit_utilization.custom_interest_type_timing"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              className="input-full loanform-input loanform-input-bg loanform-input-border"
              value={field.value ?? ''}
              data-test-id="custom-interest-type-timing-input"
            />
          )}
        />
      </div>
    </div>
  </div>
);
